import React, { useState, useEffect } from "react";
import Button from "./Button";

const Footer = (fullItemList) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [seeAll, setSeeAll] = useState(false);

  const [frontEndPagy, setFrontEndPagy] = useState({
    count: 0,
    from: 1,
    last: 1,
    next: 2,
    page: 1,
    prev: 0,
    to: 15,
  });

  const handlePageChange = (e) => {
    setSeeAll(false);
    setCurrentPage(e.target.value);
  };

  useEffect(() => {
    if (currentPage * 15 < fullItemList.length && !seeAll) {
      setFrontEndPagy({
        count: fullItemList.length,
        from: (currentPage - 1) * 15 + 1,
        last: Math.ceil(fullItemList.length / 15),
        next: parseInt(currentPage) + 1,
        page: parseInt(currentPage),
        prev: currentPage - 1,
        to: currentPage * 15,
      });
    } else {
      setFrontEndPagy({
        count: fullItemList.length,
        from: (currentPage - 1) * 15 + 1,
        last: Math.ceil(fullItemList.length / 15),
        next: null,
        page: parseInt(currentPage),
        prev: currentPage - 1,
        to: fullItemList.length,
      });
    }
  }, [fullItemList.length, currentPage, seeAll]);

  const handleSeeAll = () => {
    if (!seeAll) {
      setFrontEndPagy({
        count: fullItemList.length,
        from: 1,
        to: fullItemList.length,
      });
    } else {
      setFrontEndPagy({
        count: fullItemList.length,
        from: (currentPage - 1) * 15 + 1,
        last: Math.ceil(fullItemList.length / 15),
        next: parseInt(currentPage) + 1,
        page: parseInt(currentPage),
        prev: currentPage - 1,
        to: currentPage * 15,
      });
    }
    setSeeAll(!seeAll);
  };

  const splitItemsList = fullItemList.slice(frontEndPagy.from - 1, frontEndPagy.to);

  const renderFooter = () => {
    return (
      <footer className="text-sm mt-4 mx-8 flex justify-between">
        <div className="ml-1 mr-8">
          Showing <span className="font-bold">{frontEndPagy.from}</span> to
          <span className="font-bold"> {frontEndPagy.to} </span>of
          <span className="font-bold"> {frontEndPagy.count} </span>results
        </div>
        {seeAll ? (
          <div className="mr-8"> Showing All Results </div>
        ) : (
          <div className="mr-8">
            Page {frontEndPagy.page} of {frontEndPagy.last}
          </div>
        )}
        <div className="flex -mt-2 mb-4">
          <span>
            <Button
              value={0}
              className={seeAll ? "button-white-disabled button-md" : "button button-white button-md"}
              onClick={handleSeeAll}
              text="See All"
              disabled={false}
            ></Button>
          </span>
          <span className="ml-1">
            <Button
              value={1}
              className={frontEndPagy.page === 1 || seeAll ? "button-white-disabled button-sm" : "button button-white button-sm"}
              onClick={handlePageChange}
              text="First"
              disabled={frontEndPagy.page === 1 || seeAll}
            ></Button>
          </span>
          <span className="mx-1">
            <Button
              value={frontEndPagy.prev}
              className={frontEndPagy.prev ? "button button-white button-sm" : "button-white-disabled button-sm"}
              onClick={handlePageChange}
              text="Prev"
              disabled={!frontEndPagy.prev}
            ></Button>
          </span>
          <span>
            <Button
              value={frontEndPagy.next}
              className={frontEndPagy.next ? "button button-white button-sm" : "button-white-disabled button-sm"}
              onClick={handlePageChange}
              text="Next"
              disabled={!frontEndPagy.next}
            ></Button>
          </span>
          <span className="ml-1">
            <Button
              value={frontEndPagy.last}
              className={
                frontEndPagy.page === frontEndPagy.last
                  ? "button-white-disabled button-sm"
                  : "button button-white button-sm"
              }
              onClick={handlePageChange}
              text="Last"
              disabled={frontEndPagy.page === frontEndPagy.last}
            ></Button>
          </span>
        </div>
      </footer>
    );
  };

  return { renderFooter, splitItemsList, setCurrentPage, setSeeAll };
};

export default Footer;
